import { r as emit } from "./evx.es-DeZd_zDv.js";

if (!window.__newArrivalsQuickConfigExternalLoaded) {
  window.__newArrivalsQuickConfigExternalLoaded = true;

  document.addEventListener(
    "click",
    (event) => {
      const trigger =
        event.target && typeof event.target.closest === "function"
          ? event.target.closest("[data-new-arrivals-quick-configure]")
          : null;

      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const productUrl = trigger.getAttribute("data-product-url") || trigger.getAttribute("href");
      if (!productUrl || !document.querySelector("[data-quick-view-modal]")) return;

      emit("quick-view:open", null, { productUrl });
    },
    true
  );
}
